import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useCart } from "../../context/CartContext";

export default function ProductCard({ product, light = true }) {
  const { toggleWishlist, isWishlisted } = useCart();
  const wished = isWishlisted(product.product_id);
  const bg = light ? "bg-white" : "bg-white";
  const textCol = "text-poche-black";

  return (
    <div data-testid={`product-card-${product.product_id}`} className="group relative overflow-hidden">
      <Link to={`/product/${product.product_id}`} className="block">
        <div className={`relative ${bg} aspect-[4/5] overflow-hidden`}>
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="product-img w-full h-full object-cover"
            loading="lazy"
          />
          {product.best_seller && (
            <span className="absolute top-4 left-4 text-[10px] tracking-luxury uppercase bg-poche-black text-poche-gold px-3 py-1.5">
              Best Seller
            </span>
          )}
          {product.is_legacy && (
            <span className="absolute top-4 left-4 text-[10px] tracking-luxury uppercase bg-poche-gold text-poche-black px-3 py-1.5">
              Legacy · 25 Pieces
            </span>
          )}
          <button
            data-testid={`wish-${product.product_id}`}
            onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
            className="absolute top-4 right-4 bg-white/85 hover:bg-poche-gold w-8 h-8 flex items-center justify-center transition-colors"
            aria-label="Add to wishlist"
          >
            <Heart size={14} strokeWidth={1.5} fill={wished ? "#0A0A0A" : "none"} color="#0A0A0A" />
          </button>
        </div>
        <div className="pt-5 flex items-start justify-between gap-4">
          <div>
            <div className={`text-[11px] tracking-luxury uppercase ${textCol}/55`}>{product.name}</div>
            <div className={`font-serif text-xl mt-0.5 ${textCol}`}>{product.subtitle}</div>
          </div>
          <div className={`font-serif text-xl ${textCol}`}>
            ${product.price?.toLocaleString()}
          </div>
        </div>
        <div className="mt-3 flex items-center gap-2">
          {product.colors?.map((c, i) => (
            <span
              key={i}
              className="w-3 h-3 rounded-full border border-black/15"
              style={{ background: c }}
            />
          ))}
        </div>
      </Link>
    </div>
  );
}
